export default "__VITE_ASSET__Dz5O0MJ0__"